module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1 section",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', [_vm._v("J Fitzmaurice was born and bred in Sydney, NSW, is 70 years young, happily married and living on a hobby farm managing sheep. After leaving school, he obtained a trade certificate in electronics and worked in this field for a number of years.")]), _vm._v(" "), _c('p', [_vm._v("Shortly after getting married, he and his wife moved to rural NSW to grow fine wool merino sheep.")]), _vm._v(" "), _c('p', [_vm._v("He has always had a passion for politics and physics and has tried to combine these two interests in this book. He respects and supports the current political system and the constitution but believes positive change is necessary and possible. Like most people, he is striving to improve the human condition for future generations. He hopes this can be done by fine tuning our political structure and explaining the virtues of our current system.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c2486c48","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/ch001.vue
// module id = 63
// module chunks = 0